import React from "react";
import StationEmpity from "../../../../../public/assets/images/empityimages/StationEmpity.png"

function Info() {
  return (
    <>
    
      <img
      className="m-auto"
        src={StationEmpity}
        alt="Empity nutrition"
        width={150}
      />
      <p className="text-right text-zinc-700 text-sm max-lg:text-[15px] whitespace-nowrap max-lg:text-center max-lg:w-[90%] font-semibold">
        هیچ ایستگاه هواشناسی برای شما ثبت نشده است.
      </p>

    </>
  );
}

export default Info;
